export default "__VITE_ASSET__BCajEiHH__"